import { DsSelectOption } from "@app2/shared/components/ds-select.component";

export type TicketState = "ALL" | "ALL_OPEN_INCIDENTS" | "NEW_AND_OPEN"
    | "Triage" | "Analysis" | "Open" | "Closed" | "Invalid" | "New" | "In_Progress" | "Pending";
export type TicketView = "default" | "due-date" | "task-groups";
export type TicketDueDate = "ALL" | "HAS_DUE_DATE" | "OVERDUE" | "NO_DUE_DATE" | "DUE_TODAY" | "DUE_LATER";
export type Severity = "ALL" | "HIGH" | "MEDIUM" | "LOW" | "NONE";
export type TicketWatcherType = "all" | "state";

export type StateOptions = Array<{ value: TicketState, key: string }>;

export const incidentStateOptions: StateOptions = [
    { value: "ALL", key: "ALL" },
    { value: "ALL_OPEN_INCIDENTS", key: "ALL_OPEN_INCIDENTS" },
    { value: "Triage", key: "Triage" },
    { value: "Analysis", key: "Analysis" },
    { value: "Closed", key: "Closed" },
    { value: "Invalid", key: "INVALID" },
];

export const taskStateOptions: StateOptions = [
    { value: "NEW_AND_OPEN", key: "NEW_AND_OPEN"},
    { value: "Closed", key: "CLOSED" },
    { value: "Invalid", key: "INVALID" },
    { value: "In_Progress", key: "IN_PROGRESS_STATE" },
    { value: "Pending", key: "PENDING_STATE" },
];

export const viewOptions: Array<{ value: TicketView, key: string }> = [
    { value: "default", key: "TICKET_VIEW_DEFAULT" },
    { value: "due-date", key: "DUE_DATE" },
    { value: "task-groups", key: "TICKET_VIEW_TASK_GROUPS" },
];

export const dueDateOptions: Array<{ value: TicketDueDate, key: string }> = [
    { value: "ALL", key: "ALL" },
    { value: "HAS_DUE_DATE", key: "HAS_DUE_DATE" },
    { value: "OVERDUE", key: "OVERDUE" },
    { value: "DUE_TODAY", key: "DUE_TODAY" },
    { value: "DUE_LATER", key: "DUE_LATER" },
    { value: "NO_DUE_DATE", key: "NO_DUE_DATE" },
];

export const severityOptions: Array<{ value: Severity, key: string }> = [
    { value: "HIGH", key: "HIGH" },
    { value: "MEDIUM", key: "MEDIUM" },
    { value: "LOW", key: "LOW" },
    { value: "NONE", key: "NONE" },
];

export const taskStates: string[] = [
    "New",
    "Open",
    "In Progress",
    "Pending",
    "Invalid",
    "Closed",
];

export const taskStateSelectOptions: DsSelectOption<string>[] =
    taskStates.map(state => ({ key: state, value: state.replace(" ", "_")}));

export type SlugName = "incident" | "task" | "draft";

export const INCIDENT_SLUG = "incident";
export const TASK_SLUG = "task";
export const DRAFT_SLUG = "draft";

export const REVERSE_LINK_TYPES: Record<string, string> = {
    "DEPENDS_ON": "DEPENDED_ON_BY",
    "DEPENDED_ON_BY": "DEPENDS_ON",
    "RELATED_TO": "RELATED_TO",
    "CAUSED_BY": "CAUSES",
    "CAUSES": "CAUSED_BY",
    "DUPLICATES": "DUPLICATED_BY",
    "DUPLICATED_BY": "DUPLICATES",
    "BLOCKS": "BLOCKED_BY",
    "BLOCKED_BY": "BLOCKS",
};